import script from "./action-mote-delete.vue?vue&type=script&setup=true&lang=js"
export * from "./action-mote-delete.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__